import store from "~/store";
import {isDefined} from "~/lib/helpers/guards";

export function setupBeforeEach(router){

  router.beforeEach(async (to, from, next) => {

    if(isDefined(to.query.token)){
      await store.dispatch("restoreSession", to.query.token);
    }

    // User must be authenticated on every route
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!store.getters.isAuthenticated()) {
        return next({ name: "login", query: {r: btoa(window.location.pathname + window.location.search)}, replace: true});
      }
    }

    if (to.matched.some(record => typeof record.meta.acl === "function")) {
      if (!to.meta.acl(store.getters.abilities, store.getters.functionalities, to.params)) return next({path: "/403"});
    }

    return next();
  });

}
